import { observable, action, toJS } from 'mobx'
import _ from 'lodash'
import swal from 'sweetalert';


const selfPayComsumablestore = observable({            
    querydata:{
        nhiIdno: "",
        keyword:"",        
        nhiCode: "",
        lowPrice:"",
        highPrice:"", 
        codeNo:"",     
    },    
    
    allowSummit: false,  
    queryfactors:{},
    resultData:[], 
    allowShowData: false,   
})

const NHI_TYPE_NO ={
    'B': '容器類',
    'C': '套管類',
    'F': '人工機能代用類',
    'N': '針具類',
    'S': '縫合結紮類',
    'T': '工具類',
    'W': '傷口護理類',
    'Y': '護套、盒、帶、墊片類',
    // '人工機能代用類'
}


const loadData = (parsed)=>{    
    
    
    let payload={       

        "api": "getConsumables",
        "keyword": parsed.keyword?parsed.keyword:"", // 關鍵字
        "codeNo": parsed.codeNo?parsed.codeNo:"", // 院內代碼
        "nhiIdno": parsed.nhiIdno?parsed.nhiIdno:"", // 許可證字號
        "nhiCode": parsed.nhiCode?parsed.nhiCode:"", // 自費特材健保碼
        "lowPrice": parsed.lowPrice?parsed.lowPrice:"", // 收費標準（最低）
        "highPrice": parsed.highPrice?parsed.highPrice:"" // 收費標準（最高）
    
    }

    const url = process.env.NODE_ENV === "production" ? '/normal_api/service' : 'https://patient.kfsyscc.org/normal_api/service'
      
    fetch(url, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        })
            .then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    var error = new Error(response.statusText)
                    error.response = response;
                    throw error;
                }
            })
            .then(function (data) {    
             
                             
                                        
                selfPayComsumablestore.resultData  = data.data    
                _.map(selfPayComsumablestore.resultData, (item, key)=>{
                    selfPayComsumablestore.resultData[key]['open'] = false;
                    selfPayComsumablestore.resultData[key]['image_arr']=[]
                    if(item.IMG1!==null){
                        selfPayComsumablestore.resultData[key]['image_arr'].push(item.IMG1)
                    }
                    if(item.IMG2!==null){
                        selfPayComsumablestore.resultData[key]['image_arr'].push(item.IMG2)
                    }
                    if(item.IMG3!==null){
                        selfPayComsumablestore.resultData[key]['image_arr'].push(item.IMG3)
                    }                    
                })
               
                for(let i=0;i<selfPayComsumablestore.resultData.length; i++){
                    selfPayComsumablestore.resultData[i]['order_num']=i;
                }

                
                
               
                
                
                if(selfPayComsumablestore.resultData){
                    selfPayComsumablestore.allowShowData = true;
                }
            });
}


const loadQueryFactors = (parsed)=>{ 

    selfPayComsumablestore.queryfactors={      
        "院內代碼":"",
        "關鍵字":"",              
        "許可證字號":"", 
        "自費特材健保碼":"",       
        "價格區間":"",
    }

    // 合併價格最大最小值查詢條件顯示
    let highPrice, lowPrice;
    let combine_data = Object.assign({}, parsed); 
    if(combine_data['highPrice']){
        highPrice = combine_data['highPrice'];
    }else{
        highPrice = "";
    }
    if(combine_data['lowPrice']){
        lowPrice = combine_data['lowPrice'];
    }else{
        lowPrice = "";
    }        
    delete combine_data['highPrice']
    delete combine_data['lowPrice']

    if(lowPrice || highPrice){
        combine_data["priceRange"]=lowPrice+"~"+highPrice+"元"  
    }else{
        combine_data["priceRange"]=""
    }     

    selfPayComsumablestore.queryfactors={
        "院內代碼": combine_data.codeNo,
        "關鍵字":combine_data.keyword,              
        "許可證字號":combine_data.nhiIdno, 
        "自費特材健保碼":combine_data.nhiCode,       
        "價格區間":combine_data.priceRange,
    }
    _.each(selfPayComsumablestore.queryfactors, function(item, key){        
        if(!selfPayComsumablestore.queryfactors[key]){
            delete selfPayComsumablestore.queryfactors[key];
        }       
    })         
}
_.assign(selfPayComsumablestore, {
    setLoaddata: action(function(parsed){       
        
        loadData(parsed);
        loadQueryFactors(parsed);
        
    }),
    setValue: action(function(key, val){
        this.querydata[key] = val
    }),

    setToggleDialog: action(function (val) {                        
        let index = _.findIndex(selfPayComsumablestore.resultData, { order_num: val}); 
        let item = _.cloneDeep(toJS(selfPayComsumablestore.resultData)) ; 
        if(item[index].open){
            item[index].open = false
        }else{
            item[index].open = true
        }        
                
        selfPayComsumablestore.resultData = item       
    }),

    verifyValue: action(function() {
        var regExp = /^[\d|a-zA-Z]+$/;


        if(!regExp.test(this.querydata.nhiCode) && this.querydata.nhiCode !== ""){
            swal('自費特材健保碼請輸入英文及數字');
            return;
        }      


        if(!(this.querydata.nhiIdno >= 0 && this.querydata.nhiIdno % 1 === 0) && this.querydata.nhiIdno !== ""){                  
            swal('許可證字號請輸入數字');
            return;
        }        
        

        //lowPrice判斷
        if(this.querydata.highPrice && parseInt(this.querydata.lowPrice, 10) >  parseInt(this.querydata.highPrice, 10)){
            swal('價格區間最小值請輸入小於等於最大值的數字');  
            return;          
        }else if(!(this.querydata.lowPrice >= 0 && this.querydata.lowPrice % 1 === 0) && this.querydata.lowPrice !== ""){
            swal('價格區間最小值請輸入大於等於零的數字'); 
            return;   
        }

        //highPrice判斷
        if(this.querydata.lowPrice && parseInt(this.querydata.lowPrice, 10) >  parseInt(this.querydata.highPrice, 10)){
            swal('價格區間最大值請輸入大於等於最小值的數字');  
            return;          
        }else if(!(this.querydata.highPrice >= 0 && this.querydata.highPrice % 1 === 0) && this.querydata.highPrice !== ""){
            swal('價格區間最大值請輸入大於零的數字');  
            return;  
        } 
        
        let i = 0;     
        
        for(let key in this.querydata){
            if(!this.querydata[key]){
                i++
            }           
        }

        if(i===6){
            swal('請至少輸入一樣搜尋項目'); 
            return;
        }
        
        
        this.allowSummit = true
    }),  

    resetData: action(function(){
        _.each(selfPayComsumablestore.querydata, function(item, key){
        selfPayComsumablestore.querydata[key] = ""          
        }                      
    )  
    // loadQueryFactors();   
    this.queryfactors = {}
    this.allowShowData = false
    }),    

    // convertNhiType: action(function(type){
    //    return _.map(NHI_TYPE_NO, (item, key)=>{
    //        if(key == type){
    //            return item
    //        }else if(key == null){
    //            return "人工機能代用類"
    //        }
    //    })
    // })

})
export default selfPayComsumablestore





// WEBPACK FOOTER //
// ./src/components/store/SelfPayComsumablestore.js